import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import SwagSection from "@/components/SwagSection";
import BentoFeatures from "@/components/BentoFeatures";
import PianoShowcase from "@/components/PianoShowcase";
import Gallery from "@/components/Gallery";
import Faq from "@/components/Faq";
import DownloadCTA from "@/components/DownloadCTA";
import LegalContent from "@/components/LegalContent";
import Footer from "@/components/Footer";
import { useLanguage } from "@/context/LanguageContext";
import { content } from "@/content/fitswag";

export default function LandingPage() {
  const { lang } = useLanguage();
  const c = content[lang];
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 60);
    } else {
      window.scrollTo(0, 0);
    }
  }, [hash]);

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <SwagSection />
        <BentoFeatures />
        <PianoShowcase />
        <Gallery />
        <Faq />
        <DownloadCTA />
        <div className="border-t border-white/10">
          <LegalContent id="privacy" data={c.legal.privacy} />
        </div>
        <div className="border-t border-white/10">
          <LegalContent id="terms" data={c.legal.terms} />
        </div>
      </main>
      <Footer />
    </>
  );
}
